<template lang="html">
  <StandardDialog @click-outside="$router.push({ name: 'AccountSettings'})">
    <template #content>
      <StandardTextCard
        height="74vh"
        :name="$t('Account.Upgrade.UpgradeProUser') + ' ' + information.type.toUpperCase()"
        :clickable="false"
      >
        <template #info>
          <!-- <div class="outer-container">
            <div class="select-container">
              <StandardTextCard height="25px" name="PRO.user SINGLE" :clickable="true" @click.native="information.type = 'Single'"></StandardTextCard>
            </div>
            <div class="select-container">
              <StandardTextCard height="25px" name="PRO.user COMPANY" :clickable="true" @click.native="information.type = 'Business'"></StandardTextCard>
            </div>
          </div> -->
          <div class="clear"></div>
          <v-form v-if="information.type==='Single'">
            <v-subheader class="title">{{$t('Account.AccountSettings.Upgrade.UserInformation.Header')}}</v-subheader>
            <div class="select-container">
              <v-text-field v-model="information.single.billing_address_country" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[0]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.billing_address_zip_code" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[1]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.billing_address_state" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[2]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.billing_address_city" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[3]')" type="text"></v-text-field>
            </div>
            <div class="select-container">
              <v-text-field v-model="information.single.billing_address_street" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[4]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.billing_address_building_number" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[5]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.billing_address_custom_information" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[6]')" type="text"></v-text-field>
              <v-text-field v-model="information.single.vat_number" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[7]')" type="text"></v-text-field>
            </div>
            <div class="clear"></div>
          </v-form>
          <v-form v-if="information.type==='Business'">
            <v-subheader class="title">{{$t('Account.AccountSettings.Upgrade.CompanyInformation.Header')}}</v-subheader>
            <div class="select-container">
              <v-text-field v-model="information.business.billing_address_country" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[0]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.billing_address_zip_code" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[1]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.billing_address_state" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[2]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.billing_address_city" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[3]')" type="text"></v-text-field>
            </div>
            <div class="select-container">
              <v-text-field v-model="information.business.billing_address_street" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[4]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.billing_address_building_number" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[5]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.billing_address_custom_information" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[6]')" type="text"></v-text-field>
              <v-text-field v-model="information.business.vat_number" :label="$t('Account.AccountSettings.Upgrade.BillingInformation.Values[7]')" type="text"></v-text-field>
            </div>
            <div class="clear"></div>
            <v-text-field v-model="information.business.business_name" :label="$t('Account.AccountSettings.Upgrade.CompanyInformation.Values[0]')" type="text"></v-text-field>
            <v-text-field v-model="information.business.business_description" :label="$t('Account.AccountSettings.Upgrade.CompanyInformation.Values[1]')" type="text"></v-text-field>
            <v-text-field v-model="information.business.business_emails" :label="$t('Account.AccountSettings.Upgrade.CompanyInformation.Values[2]')" placeholder="@takting.com, @example.com" type="text"></v-text-field>
          </v-form>
        </template>
        <template #actions>
          <v-btn color="blue" text @click="requestUpgrade()">{{$t('Account.AccountSettings.Upgrade.UpgradeNow')}}</v-btn>
          <v-btn color="red" text @click="$router.push({ name: 'AccountSettings'})">{{$t('Buttons.Cancel')}}</v-btn>
        </template>
      </StandardTextCard>
    </template>
  </StandardDialog>
</template>

<script>
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountSettingsUserUpgradeFullUser',
  components: {
    StandardTextCard, StandardDialog
  },
  props: ['type'],
  data: function() {
    return {
      information: {
        // type: 'Single',
        single: {
          billing_address_country: '',
          billing_address_zip_code: '',
          billing_address_state: '',
          billing_address_city: '',
          billing_address_street: '',
          billing_address_building_number: '',
          billing_address_custom_information: '',
          vat_number: ''
        },
        business: {
          billing_address_country: '',
          billing_address_zip_code: '',
          billing_address_state: '',
          billing_address_city: '',
          billing_address_street: '',
          billing_address_building_number: '',
          billing_address_custom_information: '',
          vat_number: '',
          business_name: '',
          business_description: '',
          business_emails: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ])
  },
  created(){
    this.information.type = this.type;
  },
  methods: {
    ...mapActions('User', [
      'requestUserUpgrade'
    ]),
    requestUpgrade(){
      let information = {
        type: this.information.type
      };
      if (this.information.type === 'Single') {
        information.billing_address_country = this.information.single.billing_address_country;
        information.billing_address_zip_code = this.information.single.billing_address_zip_code;
        information.billing_address_state = this.information.single.billing_address_state;
        information.billing_address_city = this.information.single.billing_address_city;
        information.billing_address_street = this.information.single.billing_address_street;
        information.billing_address_building_number = this.information.single.billing_address_building_number;
        information.billing_address_custom_information = this.information.single.billing_address_custom_information;
        information.vat_number = this.information.single.vat_number;
      } else {
        information.billing_address_country = this.information.business.billing_address_country;
        information.billing_address_zip_code = this.information.business.billing_address_zip_code;
        information.billing_address_state = this.information.business.billing_address_state;
        information.billing_address_city = this.information.business.billing_address_city;
        information.billing_address_street = this.information.business.billing_address_street;
        information.billing_address_building_number = this.information.business.billing_address_building_number;
        information.billing_address_custom_information = this.information.business.billing_address_custom_information;
        information.vat_number = this.information.business.vat_number;
        information.business_name = this.information.business.business_name;
        information.business_description = this.information.business.business_description;
        information.business_emails = this.information.business.business_emails;
      }
      this.requestUserUpgrade({
          'requested_role': 20,
          'information': information
        });
    }
  }
}
</script>

<style lang="css" scoped>
.outer-container {
  margin: 0 auto;
  width: 50%;
}
.select-container {
  width: 45%;
  padding: 10px;
  margin: 10px;
  position: relative;
  float: left;
}
</style>
